// Guter Artikel über enums und TypeScript:
// https://www.gurustop.net/blog/2016/05/24/how-to-use-typescript-enum-with-angular2/
export enum DateiArt {
  BILD = 0,
  DOKUMENT = 1,
  VIDEO = 2,
  ALLE = 3
}
